// extracted by mini-css-extract-plugin
export default {"forceDesktop":"ManagerView_forceDesktop__VmSGG","desktop":"ManagerView_desktop__l4DCr","forceHF":"ManagerView_forceHF__qWJN3","capture":"ManagerView_capture__uUDMe"};